export default {
  list: {
    title: '消息中心',
    messageTitle: '消息',
    viewAll: '查看全部',
    searchPlaceholder: '搜索',
    markAllRead: '全部标记已读',
    settings: '消息设置',
    totalCount: '共计',
    unreadCount: '未读',
    unit: '条',
    onlyUnread: '仅未读',
    columns: {
      type: '类型',
      message: '消息内容',
      time: '请配时间',
      operations: '操作'
    },
    operations: {
      markRead: '标记已读',
      markUnread: '标记未读',
      view: '转已读'
    }
  },
  tabs: {
    unread: '通知',
    all: '公告'
  },
  categories: {
    all: '全部',
    job: '职位',
    candidate: '选考'
  },
  status: {
    unread: '未读',
    read: '已读'
  },
  types: {
    // 职位相关
    jobPosted: '职位发布',
    jobOpened: '职位开放',
    jobClosed: '职位关闭',

    // 选考相关
    newApplication: '新投递',
    selectionStageChanged: '选考状态变更',
    interviewScheduleSent: '面试日程已发出',
    interviewScheduleAccepted: '面试日程已接受',
    interviewSchedulePending: '面试日程待调整',
    interviewScheduleAdjusted: '面试日程已调整',
    interviewScheduleExpired: '面试日程已过期',
    interviewScheduleRescheduled: '面试日程重新预约',
    joinDateConfirmed: '确认入职日期',
    joined: '确认入职',
    selectionTerminated: '选考终止',
    internalMessage: '内部留言',
    externalContact: '外部联络'
  },
  messages: {
    markAllReadSuccess: '全部已标记为已读',
    markReadSuccess: '已标记为已读',
    markUnreadSuccess: '已标记为未读',
    viewDetail: '查看详情'
  },
  announcementDialog: {
    confirm: '我知道了'
  },
  settings: {
    pageTitle: '消息设置',
    breadcrumb: {
      messageCenter: '消息中心',
      messageSettings: '消息设置'
    },
    jobSection: '职位',
    candidateSection: '选考',
    selfReceive: '自己是否接收',
    recipients: '接收对象',
    settingButton: '设置',
    onlySuperAdmin: '由超管/管理员统一设置',
    defaultRecipients: '候选人负责人、选考负责人',
    externalRecipients: '选考负责人',
    recipientsCount: '{count}个',
    updateSuccess: '设置已更新',
    updateFailed: '设置更新失败',
    recipientUpdateSuccess: '接收对象已更新',
    recipientUpdateFailed: '接收对象更新失败',
    loadFailed: '加载设置失败'
  },
  recipientDialog: {
    title: '设置接收对象',
    subtitle: '请选择模板「{title}」的接收对象',
    searchPlaceholder: '角色/账号用户名',
    defaultSend: '默认发送',
    roles: '角色',
    accounts: '账号',
    selected: '已选择',
    candidateOwner: '候选人负责人',
    selectionOwner: '选考负责人'
  },
  // 消息模板
  messageTemplates: {
    // 企业端模板
    jobPublish: '[[userName]] 发布了新职位：[[jobTitle]]',
    jobOpen: '职位：[[jobTitle]] 已对以下猎头公司开放：[[headhunterCompanyNames]]',
    jobClose: '[[userName]] 关闭了职位：[[jobTitle]]',
    newApplication: '职位：[[jobTitle]] 收到新投递',
    selectionStatusChange: '候选人 [[candidateName]] 的选考已进入 [[stepName]] 阶段',
    interviewScheduleSent: '候选人 [[candidateName]] 的面试日程（[[stepName]]）已发出，面试时间待确认',
    interviewScheduleAccepted: '候选人 [[candidateName]] 的面试日程（[[stepName]]）已接受，面试时间为：[[interviewTime]]',
    interviewSchedulePending: '候选人 [[candidateName]] 的面试日程（[[stepName]]）',
    interviewScheduleAdjusted: '候选人 [[candidateName]] 的面试日程（[[stepName]]）',
    interviewScheduleExpired: '候选人 [[candidateName]] 的面试日程（[[stepName]]）',
    interviewScheduleRescheduled: '候选人 [[candidateName]] 的面试日程（[[stepName]]）',
    confirmJoinDate: '候选人 [[candidateName]] 已确认入职日期：[[joinDate]]',
    confirmJoin: '候选人 [[candidateName]] ',
    selectionTerminate: '候选人 [[candidateName]] 的选考在 [[stepName]] ',
    internalComment: '[[userName]] 在候选人 [[candidateName]] 的选考页面留言了：[[remarkContent]]',
    externalContact: '[[userName]] 在候选人 [[candidateName]] 的选考页面留言了：[[remarkContent]]',
    // 猎头端模板（productId === 3）
    agent: {
      jobPublish: '[[userName]] 发布了新职位：[[jobTitle]]',
      jobOpen: '[[enterpriseName]] 的职位 [[jobTitle]] 已对贵公司开放',
      jobClose: '[[enterpriseName]] 关闭了职位「[[jobTitle]]」',
      newApplication: '候选人 [[candidateName]] 投递了职位 [[jobTitle]]',
      selectionStatusChange: '候选人 [[candidateName]] 的选考已进入 [[stepName]] 阶段',
      interviewScheduleSent: '候选人 [[candidateName]] 的面试日程（[[stepName]]）已发出，面试时间待确认',
      interviewScheduleAccepted: '候选人 [[candidateName]] 的面试日程（[[stepName]]）已接受，面试时间为：[[interviewTime]]',
      interviewSchedulePending: '候选人 [[candidateName]] 的面试日程（[[stepName]]）',
      interviewScheduleAdjusted: '候选人 [[candidateName]] 的面试日程（[[stepName]]）',
      interviewScheduleExpired: '候选人 [[candidateName]] 的面试日程（[[stepName]]）',
      interviewScheduleRescheduled: '候选人 [[candidateName]] 的面试日程（[[stepName]]）',
      confirmJoinDate: '候选人 [[candidateName]] 已确认入职日期：[[joinDate]]',
      confirmJoin: '候选人 [[candidateName]] ',
      selectionTerminate: '候选人 [[candidateName]] 的选考在 [[stepName]] ',
      internalComment: '[[userName]] 在候选人 [[candidateName]] 的选考页面留言了：[[remarkContent]]',
      externalContact: '[[userName]] 在候选人 [[candidateName]] 的选考页面留言了：[[remarkContent]]'
    },
    // 固定文案
    candidateSource: '候选人来源：',
    enterpriseName: '招聘企业：',
    requestAdjustTime: '申请调整面试时间',
    remark: '备注：',
    adjusted: '已调整',
    expired: '已过期',
    awaitingReschedule: '，待重新预约',
    rescheduled: '已重新预约',
    awaitingConfirm: '，面试时间待确认',
    confirmedJoin: '已确认入职',
    terminateStage: '阶段终止，',
    terminateReason: '终止理由：',
    terminated: '终止',
    stage: '，'
  }
};
